import React from "react";
import "./index.css";
import { MdDone } from "react-icons/md";
import { MdClear } from "react-icons/md";

function Step({ item, lastItem = false, index }) {
  return (
    <div className={`step-content${lastItem ? "-last" : ""}`}>
      <div className="step-info">
        <div
          className={`step-index${
            item.status === "process"
              ? ""
              : item.status === "wait"
              ? "-wait"
              : item.status === "finish"
              ? "-finish"
              : item.status === "error"
              ? "-error"
              : ""
          }`}
        >
          {item.status === "wait" || item.status === "process" ? index + 1 : ""}
          {item.status === "finish" ? (
            <MdDone style={{ fontSize: "18px" }} />
          ) : (
            ""
          )}
          {item.status === "error" ? (
            <MdClear style={{ fontSize: "18px" }} />
          ) : (
            ""
          )}
        </div>
        <div
          className={`step-title${
            item.status === "error"
              ? "-error"
              : item.status === "wait"
              ? "-wait"
              : ""
          }`}
        >
          {item.title}
        </div>
        {!lastItem ? (
          <div
            className={`step-divider${item.status === "wait" ? "-wait" : ""}`}
          ></div>
        ) : null}
      </div>
      <div
        className={`step-desc${
          item.status === "error"
            ? "-error"
            : item.status === "process"
            ? "-process"
            : ""
        }`}
      >
        {item.description}
      </div>
    </div>
  );
}

export default function MySteps({ items }) {
  return (
    <div className="ms-content">
      {items.map((item, idx) => {
        return (
          <Step
            key={idx}
            index={idx}
            item={item}
            lastItem={idx === items.length - 1 ? true : false}
          />
        );
      })}
    </div>
  );
}
